import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatIconModule } from '@angular/material/icon';
import { TerminalModule } from '@zerops/zerops/feature/terminal';
import { ZuiClaudeMarkComponent } from '@zerops/zui/claude-mark';
import { ZuiCodexMarkComponent } from '@zerops/zui/codex-mark';
import { ZuiAntigravityMarkComponent } from '@zerops/zui/antigravity-mark';
import { ZuiGrokMarkComponent } from '@zerops/zui/grok-mark';
import { ZuiCursorMarkComponent } from '@zerops/zui/cursor-mark';
import { ZuiAgentStripComponent } from '@zerops/zui/agent-strip';
import { ZuiSeparatorComponent } from '@zerops/zui/separator';
import { ZefDialogModule } from '@zerops/zef/dialog';
import { ZefFormsModule } from '@zerops/zef/forms';
import { ZefScrollbarComponent } from '@zerops/zef/scrollbar';
import { ZcpAgentAuthDialogFeature } from './zcp-agent-auth-dialog.feature';
import { ZcpAgentAuthDialogEffect } from './zcp-agent-auth-dialog.effect';
import { zcpAgentAuthDialogFeature } from './zcp-agent-auth-dialog.state';

@NgModule({
  declarations: [ ZcpAgentAuthDialogFeature ],
  imports: [
    CommonModule,
    ZefDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    ZefFormsModule,
    ZefScrollbarComponent,
    TerminalModule,
    ZuiClaudeMarkComponent,
    ZuiCodexMarkComponent,
    ZuiAntigravityMarkComponent,
    ZuiGrokMarkComponent,
    ZuiCursorMarkComponent,
    ZuiAgentStripComponent,
    ZuiSeparatorComponent,
    StoreModule.forFeature(zcpAgentAuthDialogFeature),
    EffectsModule.forFeature([ ZcpAgentAuthDialogEffect ])
  ],
  exports: [ ZcpAgentAuthDialogFeature ]
})
export class ZcpAgentAuthDialogModule {}
